import { zeroTabsStyles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';
import { ElementDefinitionContext, FoundationElementDefinition } from '@microsoft/fast-foundation';
import { scrollbarStyles } from '../../../styles/styles';
import { mixinRobotoMedium } from '../../../styles';

export const customTabsStyles = (
  context: ElementDefinitionContext,
  definition: FoundationElementDefinition
): ElementStyles => css`
  ${zeroTabsStyles(context, definition)}
  ${scrollbarStyles}

  .end {
    padding-right: 5px !important;
  }

  :host ::slotted(.tab-title) {
    font-size: 13px;
    font-weight: 500!important;
    color: var(--white-smoke);
    ${mixinRobotoMedium()}
  }
`;
